import { EventCodes } from '../../../../../App/model/event-codes';

angular.module('mx.SolutionBuilderAgent').service('mx.SolutionBuilderAgent.RecentService', RecentService);
RecentService.$inject = [
	'mx.internationalization',
	'mx.shell.EventService',
	'mx.shell.LeftSidebarService',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.SolutionBuilderAgent.WidgetManager',
	'mx.shell.NavigationManager',
	'mx.shell.AppsService',
	'mx.shell.SidePanelService',
	'mx.shell.SideLayout',
];

export function RecentService(i18n, eventService, leftSidebarService, personalizationService, widgetManager, navigationManager, appsService, sidePanelService, sideLayoutService) {
	const self = this;
	var initialized = false;

	var recentWithoutInProgressViews = [],
		recentViews = [],
		isActivatedManually = false;

	var MAX_RECENT_SIZE = 20;

	self.init = init;
	self.addToRecent = addToRecent;
	self.openRecentView = openRecentView;
	self.clearRecent = clearRecent;

	return self;

	function init() {
		appsService.getCurrentApplication().then(function (app) {
			self.enabled = !app.simpleNavigation && app.showRecent;

			if (self.enabled && !initialized) {
				initService();
			}
		});
	}

	function initService() {
		initialized = true;

		leftSidebarService.addPanel({
			name: 'recent',
			icon: 'history',
			title: i18n.get('solutionBuilderAgent.components.mx-recent-items-panel.recentItems'),
			order: 20,
			disable: true,
			content: '<mx-recent-items-panel></mx-recent-items-panel>',
		});

		Object.defineProperty(self, 'recentWithoutInProgressViews', {
			get: function () {
				return recentWithoutInProgressViews;
			},
		});

		eventService.subscribeGlobal(mx.shell.EventCodes.SidePanelInProgressViewsChanged, function () {
			updateRecentAndOpenedViewList();
		});

		eventService.subscribeGlobal(mx.SolutionBuilderAgent.Events.ViewDataLoaded, function (e, view) {
			addToRecent(view);
		});

		eventService.subscribeGlobal(mx.shell.EventCodes.LeftSidebarTabChanged, (e, { isTabChangedByUserManually, panelName }) => {
			isActivatedManually = isTabChangedByUserManually && panelName === 'recent';
		});

		eventService.subscribeGlobal(mx.SolutionBuilderAgent.Events.ObjectDataDeleted, function (e, data) {
			if (data && Array.isArray(data.affectedObjectIds)) {
				data.affectedObjectIds.forEach(function (objectId) {
					var object = { Id: objectId };
					removeFromRecent(object);
				});
			}
		});

		eventService.subscribeGlobal(mx.SolutionBuilderAgent.Events.ObjectDisplayNameChanged, function (e, params) {
			var needSave = false;
			recentViews.forEach(function (view) {
				if (view.id === params.objectId && view.type === params.entityType) {
					view.displayName = params.displayName;
					needSave = true;
				}
			});
			if (needSave) {
				saveRecentViews();
			}
		});

		eventService.subscribeGlobal(mx.shell.EventCodes.ObjectRemovedByWizard, function (e, object) {
			removeFromRecent(object);
		});

		initRecentViews();
	}

	async function initRecentViews() {
		const recentObjectDetails = await personalizationService.getRecentViews();
		recentViews.length = 0;

		const views = await Promise.all(recentObjectDetails.map((objectDetails) => widgetManager.getPreviewView(objectDetails)));

		views
			.filter((view) => view && typeof view === 'object')
			.forEach((view, index) => {
				const duplicate = recentViews.some((rView) => !view || (view.id === rView.id && view.type === rView.type));
				if (!duplicate) {
					view.openingTime = views.length - index;
					recentViews.push(view);
				}
			});
		updateRecentAndOpenedViewList();
	}

	async function addToRecent(view) {
		view.openingTime = view.openingTime || Date.now();

		if (view.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit || view.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview) {
			const initialObjectDetails = sidePanelService.getObjectDetailsFromView(view);

			recentViews.some(function (rView, index) {
				if (rView.context._id === view.context._id /* && rView.type === view.type*/) {
					recentViews.splice(index, 1);
					return true;
				}
			});

			if (view.finishDefer) {
				recentViews.unshift(view);
				view.finishDefer.promise.catch(mx.logCatch).finally(async function () {
					const newObjectDetails = sidePanelService.getObjectDetailsFromView(view);
					const newView = await widgetManager.getPreviewView(newObjectDetails);

					const index = recentViews.indexOf(view);
					if (index < 0) {
						return;
					}
					newView.openingTime = view.openingTime;
					newView.context._displayName = view.context._displayName;
					recentViews[index] = newView;

					if (JSON.stringify(initialObjectDetails) !== JSON.stringify(newObjectDetails)) {
						saveRecentViews();
					}

					updateRecentAndOpenedViewList();
				});
			} else {
				const recentView = await widgetManager.getPreviewView(initialObjectDetails);
				recentView.openingTime = view.openingTime;
				recentViews.unshift(recentView);
			}

			if (recentViews.length > MAX_RECENT_SIZE) {
				recentViews.splice(recentViews.length - 1, 1);
			}
		}

		saveRecentViews();
		updateRecentAndOpenedViewList();
		return recentViews;
	}

	function removeFromRecent(object) {
		recentViews
			.filter(function (rView) {
				return rView.id === object.Id && (!object.EntityType || rView.type === object.EntityType);
			})
			.forEach(function (removeView) {
				recentViews.splice(recentViews.indexOf(removeView), 1);
			});

		saveRecentViews();
		updateRecentAndOpenedViewList();
	}

	function saveRecentViews() {
		personalizationService.saveRecentViews(recentViews.map(sidePanelService.getObjectDetailsFromView));
	}

	async function openRecentView(view) {
		eventService.dispatchEvent(EventCodes.TrackViewTelemetry, {
			eventName: 'Recent item opened',
			view,
		});

		isActivatedManually = true;
		if (sidePanelService.isViewOpened(view)) {
			sidePanelService.addView(view).catch(mx.logCatch);
		} else {
			const objDetails = sidePanelService.getObjectDetailsFromView(view);
			const newView = await widgetManager.getPreviewView(objDetails);
			if (newView) {
				newView.openingTime = view.openingTime;
				sidePanelService.addView(newView).catch(mx.logCatch);
			}
		}

		sidePanelService.handleItemSelectionOnMobile();
	}

	function clearRecent() {
		recentViews.length = 0;
		saveRecentViews();
		updateRecentAndOpenedViewList();
	}

	function checkRecentPanelStatus() {
		if (recentWithoutInProgressViews.length || sidePanelService.inProgressViews.length) {
			leftSidebarService.enablePanel('recent');
			if (sidePanelService.currentView?.tabs?.length > 1 || sidePanelService.currentView?.locals?.wizard?.allWizardSteps?.length > 1) {
				navigationManager.collapsedMode = false;
				leftSidebarService.showPanelByName('recent');
			} else if (!isActivatedManually && !sideLayoutService.fullScreenMode && leftSidebarService.getCurrentPanelName() === 'recent') {
				leftSidebarService.showPanelByName('navigation');
			}
		} else {
			leftSidebarService.disablePanel('recent');
		}
	}

	function updateRecentAndOpenedViewList() {
		recentWithoutInProgressViews = recentViews
			.filter(function (view) {
				return !sidePanelService.isViewInProgress(view);
			})
			.sort(function (viewA, viewB) {
				return viewA.openingTime < viewB.openingTime ? 1 : viewA.openingTime === viewB.openingTime ? 0 : -1;
			});

		checkRecentPanelStatus();

		return recentWithoutInProgressViews;
	}
}
